import IcTrash from '@/assets/icons/ic-trash.svg';

export const RemovePageButton = ({ onClick }: { onClick: () => void }) => (
    <button
        type='button'
        onClick={onClick}
        className='text-gray hover:text-negative flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-md transition-colors'
        aria-label='Remove page'
    >
        <IcTrash className='size-5' />
    </button>
);
